<template>
  <div class="chart-wrap">
    <div class="bars-container">
      <div
        v-for="entry in revenueDistribution.data"
        :key="entry.value"
        :style="{backgroundColor: entry.color, width: `${entry.barWidth}px`}"
        v-tooltip="{
          content: entry.titleText,
          delay: {show: 0, hide: 0},
          offset: 10,
        }"
        class="bar"
      ></div>
    </div>
    <div class="labels">
      <label v-if="revenueDistribution.labels.low" class="low">{{ revenueDistribution.labels.low }}</label>
      <label
        v-if="revenueDistribution.labels.high && revenueDistribution.labels.high !== revenueDistribution.labels.low"
        class="high"
      >{{ revenueDistribution.labels.high }}</label>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import optionsData from '@/data/options'

const chartWidth = 175

export default {
  name: 'revenue-chart',
  computed: {
    ...mapGetters({
      visibleCompanies: 'companies/inBoundsCompanies',
    }),
    revenueDistribution() {
      const counts = {}
      let companiesTotal = 0
      this.visibleCompanies.forEach(company => {
        if (company.data && company.data._consolidatedFinRevenueRange) {
          counts[company.data._consolidatedFinRevenueRange] =
            counts[company.data._consolidatedFinRevenueRange] || 0
          counts[company.data._consolidatedFinRevenueRange] += 1
          companiesTotal += 1
        }
      })

      const distribution = optionsData.revenueOptions
        .map(option => {
          return { ...option, count: counts[option.value] }
        })
        .filter(option => !!option.count)
        .map(option => ({
          ...option,
          barWidth: (chartWidth * option.count) / companiesTotal,
          titleText: `<b>${option.text}</b><br> ${option.count} compan${
            option.count === 1 ? 'y' : 'ies'
          }`,
        }))

      let labels = {}
      if (distribution.length) {
        labels = {
          low: distribution[0].text,
          high: distribution[distribution.length - 1].text,
        }
      } else {
        distribution.push({
          barWidth: chartWidth,
          color: '#ddd',
          titleText: 'No companies with current filter',
        })
        labels.low = '0'
      }
      return {
        companiesTotal,
        data: distribution,
        labels,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.chart-wrap {
  width: 175px;
  margin: 0 10px;
  padding-top: 3px;
  .bars-container {
    display: flex;
  }
  .bar {
    height: 10px;
    margin-right: 2px;
    display: inline-block;
    transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .labels {
    display: flex;
    margin-top: 7px;
    label {
      flex: 1;
      font-size: 12px;
      white-space: nowrap;
      color: #8f949a;

      &.high {
        text-align: right;
      }
    }
  }
}
</style>
